<template>
  <div>
    <span
      class="uk-badge"
      v-bind:class="{'uk-badge-green': isGreen, 'uk-badge-red': isRed, 'uk-badge-orange': isOrange}"
    >
      <slot></slot>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    badgeStyle: {
      default: 'default',
    },
    isGreen: {
      default: false,
    },
    isRed: {
      default: false,
    },
    isOrange: {
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.uk-badge-green {
  background-color: #11c178;
}
.uk-badge-red {
  background-color: #f01e1e;
}
.uk-badge-orange {
  background-color: #ff6937;
}
</style>
